import React from 'react'

const CreditCard = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7778 6H6.22222C5 6 4 7 4 8.22222V19.7778C4 21 5 22 6.22222 22H21.7778C23 22 24 21 24 19.7778V8.22222C24 7 23.0111 6 21.7778 6ZM16.7 15.4889L15.4333 16L16.6556 17.2222C16.8889 17.4556 16.8889 17.8222 16.6556 18.0556L16.4556 18.2556C16.2222 18.4889 15.8556 18.4889 15.6222 18.2556L14.4 17.0333L13.8889 18.3C13.7889 18.5444 13.4444 18.5444 13.3444 18.3L11.1444 13.1333C11.0444 12.8889 11.2889 12.6444 11.5333 12.7444L16.7 14.9333C16.9444 15.0444 16.9444 15.3889 16.7 15.4889ZM22.1111 10.4333H5.88889C5.76667 10.4333 5.66667 10.3333 5.66667 10.2111V8.22222C5.66667 7.91111 5.91111 7.66667 6.22222 7.66667H21.7778C22.0889 7.66667 22.3333 7.91111 22.3333 8.22222V10.2111C22.3333 10.3333 22.2333 10.4333 22.1111 10.4333Z"
        fill="#1072EB"
      />
    </svg>
  )
}

export default CreditCard
